module.exports = __webpack_public_path__ + "static/media/phone-frame.149d1f07.png";